const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL?.trim() ?? '';
const SUPABASE_ANON_KEY = import.meta.env.VITE_SUPABASE_ANON_KEY?.trim() ?? '';
const MOCK_EMAIL = import.meta.env.VITE_MOCK_AUTH_EMAIL?.trim() ?? '';
const MOCK_PASSWORD = import.meta.env.VITE_MOCK_AUTH_PASSWORD?.trim() ?? '';
const IS_PROD = import.meta.env.PROD;

export const env = {
  supabaseUrl: SUPABASE_URL,
  supabaseAnonKey: SUPABASE_ANON_KEY,
  // Mock creds only available in non-prod builds. Prod always requires real Supabase.
  mockAuthEmail: IS_PROD ? '' : MOCK_EMAIL,
  mockAuthPassword: IS_PROD ? '' : MOCK_PASSWORD,
  isMock: SUPABASE_URL === '' || SUPABASE_ANON_KEY === '',
} as const;
